import { render } from "./HomeBottom.vue?vue&type=template&id=f7a27d0e&scoped=true"
import script from "./HomeBottom.vue?vue&type=script&lang=js"
export * from "./HomeBottom.vue?vue&type=script&lang=js"

import "./HomeBottom.vue?vue&type=style&index=0&id=f7a27d0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7a27d0e"]])

export default __exports__